// NomiTail product gallery videos: show an obvious control bar and keep native controls available.
(function () {
  var PRODUCT_VIDEO_CONTAINER_SELECTOR = '.product-media-container--video';
  var DEFERRED_SELECTOR = PRODUCT_VIDEO_CONTAINER_SELECTOR + ' deferred-media';
  var VIDEO_SELECTOR = PRODUCT_VIDEO_CONTAINER_SELECTOR + ' video';
  var POSTER_BUTTON_SELECTOR = PRODUCT_VIDEO_CONTAINER_SELECTOR + ' .deferred-media__poster-button';
  var STYLE_ID = 'nomitail-product-video-controls-ui-style';
  var UI_CLASS = 'nomitail-product-video-ui';
  var ROW_CLASS = 'nomitail-product-video-row';
  var SPACER_CLASS = 'nomitail-product-video-spacer';
  var BUTTON_CLASS = 'nomitail-product-video-button';
  var CENTER_BUTTON_CLASS = 'nomitail-product-video-center-play';
  var PROGRESS_CLASS = 'nomitail-product-video-progress';
  var TIME_CLASS = 'nomitail-product-video-time';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.product-media-container--video{position:relative;background:#000;overflow:hidden;}',
      '.product-media-container--video .product-media{position:relative;}',
      '.product-media-container--video .product-media > video{position:absolute;inset:0;width:100%;height:100%;display:block;background:#000;object-fit:contain;}',
      '.product-media-container--video deferred-media{position:absolute;inset:0;width:100%;height:100%;}',
      '.product-media-container--video deferred-media > video,.product-media-container--video deferred-media > iframe,.product-media-container--video .deferred-media__poster-image{position:absolute;inset:0;width:100%;height:100%;background:#000;object-fit:contain;}',
      '.product-media-container--video .deferred-media__poster-button{position:absolute;inset:0;width:100%;height:100%;padding:0;margin:0;z-index:2;display:block;}',
      '.product-media-container--video .deferred-media__poster-button[hidden]{display:none!important;}',
      '.product-media-container--video .deferred-media__poster-icon{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:3;pointer-events:none;}',
      '.product-media-container--video .deferred-media__poster-button svg{width:22px;height:22px;}',
      '.product-media-container--video .'+UI_CLASS+'{position:absolute;left:0;right:0;bottom:0;z-index:20;display:flex;flex-direction:column;justify-content:flex-end;gap:8px;min-height:86px;padding:28px 20px 12px;background:linear-gradient(to top, rgba(0,0,0,.82) 0%, rgba(0,0,0,.58) 48%, rgba(0,0,0,0) 100%);color:#fff;border:0;border-radius:0;box-shadow:none;pointer-events:auto;}',
      '.product-media-container--video .'+UI_CLASS+'[hidden]{display:none!important;}',
      '.product-media-container--video .'+ROW_CLASS+'{display:flex;align-items:center;gap:12px;width:100%;min-width:0;}',
      '.product-media-container--video .'+SPACER_CLASS+'{flex:1;min-width:18px;}',
      '.product-media-container--video .'+BUTTON_CLASS+'{display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;min-width:30px;min-height:30px;padding:0;border:0;border-radius:4px;background:transparent;color:#fff;cursor:pointer;appearance:none;}',
      '.product-media-container--video .'+BUTTON_CLASS+':hover{background:rgba(255,255,255,.14);}',
      '.product-media-container--video .'+BUTTON_CLASS+' svg{width:19px;height:19px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}',
      '.product-media-container--video .nomitail-product-video-play svg{fill:currentColor;stroke:none;}',
      '.product-media-container--video .'+CENTER_BUTTON_CLASS+'{position:absolute;left:50%;top:50%;z-index:21;display:inline-flex;align-items:center;justify-content:center;width:68px;height:68px;padding:0;border:1px solid rgba(255,255,255,.36);border-radius:999px;background:rgba(0,0,0,.5);color:#fff;box-shadow:0 18px 44px rgba(0,0,0,.28);transform:translate(-50%,-50%);cursor:pointer;appearance:none;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);}',
      '.product-media-container--video .'+CENTER_BUTTON_CLASS+':hover{background:rgba(0,0,0,.64);}',
      '.product-media-container--video .'+CENTER_BUTTON_CLASS+'[hidden]{display:none!important;}',
      '.product-media-container--video .'+CENTER_BUTTON_CLASS+' svg{width:28px;height:28px;margin-left:3px;fill:currentColor;stroke:none;}',
      '.product-media-container--video .'+PROGRESS_CLASS+'{width:100%;appearance:none;-webkit-appearance:none;height:4px;border:0;border-radius:999px;outline:none;cursor:pointer;background:linear-gradient(to right, #fff 0, #fff var(--nomitail-video-progress, 0%), rgba(255,255,255,.42) var(--nomitail-video-progress, 0%), rgba(255,255,255,.42) 100%);}',
      '.product-media-container--video .'+PROGRESS_CLASS+'::-webkit-slider-thumb{appearance:none;-webkit-appearance:none;width:12px;height:12px;border:0;border-radius:999px;background:#fff;box-shadow:0 0 0 1px rgba(0,0,0,.12);}',
      '.product-media-container--video .'+PROGRESS_CLASS+'::-moz-range-thumb{width:12px;height:12px;border:0;border-radius:999px;background:#fff;box-shadow:0 0 0 1px rgba(0,0,0,.12);}',
      '.product-media-container--video .'+PROGRESS_CLASS+'::-moz-range-track{height:4px;border:0;border-radius:999px;background:rgba(255,255,255,.28);}',
      '.product-media-container--video .'+TIME_CLASS+'{font-size:15px;line-height:1;white-space:nowrap;opacity:.95;min-width:82px;text-align:left;font-variant-numeric:tabular-nums;}',
      '@media(max-width:749px){.product-media-container--video>.product-media-constraint-wrapper,.product-media-container--video>.product-media-constraint-wrapper>.product-media{width:100%!important;height:100%!important;min-height:0!important;max-height:100%!important;aspect-ratio:inherit!important}.product-media-container--video .product-media>video{height:100%!important;max-height:100%!important;object-fit:contain!important}.product-media-container--video .'+UI_CLASS+'{min-height:76px;padding:24px 14px 10px;gap:7px}.product-media-container--video .'+ROW_CLASS+'{gap:8px}.product-media-container--video .'+BUTTON_CLASS+'{width:28px;height:28px;min-width:28px;min-height:28px}.product-media-container--video .'+BUTTON_CLASS+' svg{width:17px;height:17px}.product-media-container--video .'+CENTER_BUTTON_CLASS+'{width:58px;height:58px}.product-media-container--video .'+CENTER_BUTTON_CLASS+' svg{width:24px;height:24px}.product-media-container--video .'+PROGRESS_CLASS+'{height:3px}.product-media-container--video .'+TIME_CLASS+'{min-width:70px;font-size:12px}}',
    ].join('');
    document.head.appendChild(style);
  }

  function normalizeVideo(video) {
    if (!(video instanceof HTMLVideoElement)) return;
    if (!video.closest(PRODUCT_VIDEO_CONTAINER_SELECTOR)) return;

    video.controls = false;
    video.removeAttribute('controls');
    video.setAttribute('controlsList', 'nodownload');
    video.setAttribute('oncontextmenu', 'return false;');
    video.autoplay = false;
    video.removeAttribute('autoplay');
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', 'playsinline');
    video.preload = 'metadata';
    video.setAttribute('preload', 'metadata');
  }

  function hidePoster(deferredMedia) {
    if (!(deferredMedia instanceof HTMLElement)) return;

    var posterButton = deferredMedia.querySelector('.deferred-media__poster-button');
    if (!posterButton) return;

    posterButton.hidden = true;
    posterButton.style.display = 'none';
    posterButton.style.pointerEvents = 'none';
  }

  function playVideo(video) {
    if (!(video instanceof HTMLVideoElement)) return;

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function formatTime(seconds) {
    if (!isFinite(seconds) || seconds < 0) return '0:00';
    var wholeSeconds = Math.floor(seconds);
    var minutes = Math.floor(wholeSeconds / 60);
    var remainder = String(wholeSeconds % 60).padStart(2, '0');
    return String(minutes) + ':' + remainder;
  }

  function createIcon(kind) {
    if (kind === 'pause') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 5v14"></path><path d="M17 5v14"></path></svg>';
    }
    if (kind === 'mute') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 9v6h4l5 4V5L8 9H4Z"></path><path d="m17 9 4 4m0-4-4 4"></path></svg>';
    }
    if (kind === 'unmute') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 9v6h4l5 4V5L8 9H4Z"></path><path d="M16 8.5a5 5 0 0 1 0 7"></path><path d="M18.5 6a8.5 8.5 0 0 1 0 12"></path></svg>';
    }
    if (kind === 'fullscreen') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 3H3v5"></path><path d="M16 3h5v5"></path><path d="M3 16v5h5"></path><path d="M16 21h5v-5"></path></svg>';
    }
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z"></path></svg>';
  }

  function stopPropagation(event) {
    event.stopPropagation();
  }

  function ensureControls(video) {
    if (!(video instanceof HTMLVideoElement)) return;
    if (!video.closest(PRODUCT_VIDEO_CONTAINER_SELECTOR)) return;
    if (video.dataset.nomitailVideoControlsReady === 'true') return;

    var media = video.closest('.product-media');
    if (!(media instanceof HTMLElement)) return;
    var frame = video.closest(PRODUCT_VIDEO_CONTAINER_SELECTOR);
    if (!(frame instanceof HTMLElement)) frame = media;

    video.dataset.nomitailVideoControlsReady = 'true';

    var ui = document.createElement('div');
    ui.className = UI_CLASS;
    ui.setAttribute('role', 'group');
    ui.setAttribute('aria-label', 'Video controls');

    var row = document.createElement('div');
    row.className = ROW_CLASS;

    var playButton = document.createElement('button');
    playButton.type = 'button';
    playButton.className = BUTTON_CLASS + ' nomitail-product-video-play';
    playButton.setAttribute('aria-label', 'Play video');
    playButton.innerHTML = createIcon('play');

    var centerButton = document.createElement('button');
    centerButton.type = 'button';
    centerButton.className = CENTER_BUTTON_CLASS;
    centerButton.setAttribute('aria-label', 'Play video');
    centerButton.innerHTML = createIcon('play');

    var progress = document.createElement('input');
    progress.type = 'range';
    progress.min = '0';
    progress.max = '1000';
    progress.step = '1';
    progress.value = '0';
    progress.className = PROGRESS_CLASS;
    progress.setAttribute('aria-label', 'Video progress');

    var time = document.createElement('span');
    time.className = TIME_CLASS;
    time.textContent = '0:00 / 0:00';

    var muteButton = document.createElement('button');
    muteButton.type = 'button';
    muteButton.className = BUTTON_CLASS + ' nomitail-product-video-mute';
    muteButton.setAttribute('aria-label', 'Mute video');
    muteButton.innerHTML = createIcon('mute');

    var fullscreenButton = document.createElement('button');
    fullscreenButton.type = 'button';
    fullscreenButton.className = BUTTON_CLASS + ' nomitail-product-video-fullscreen';
    fullscreenButton.setAttribute('aria-label', 'Fullscreen');
    fullscreenButton.innerHTML = createIcon('fullscreen');

    var spacer = document.createElement('span');
    spacer.className = SPACER_CLASS;

    function positionControls() {
      var slide = video.closest('slideshow-slide');
      var rect = frame.getBoundingClientRect();
      var isCurrentSlide = !slide || slide.getAttribute('aria-hidden') !== 'true';
      var isVisible = rect.width > 80 && rect.height > 80 && rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;

      if (!isCurrentSlide || !isVisible) {
        ui.hidden = true;
        centerButton.hidden = true;
        return;
      }

      ui.hidden = false;
      centerButton.hidden = !video.paused;

      if (rect.bottom > window.innerHeight) {
        var left = Math.max(0, rect.left);
        var right = Math.min(window.innerWidth, rect.right);
        var top = Math.max(0, rect.top);
        var bottom = Math.min(window.innerHeight, rect.bottom);
        var width = Math.max(160, right - left);

        ui.style.position = 'fixed';
        ui.style.left = left + 'px';
        ui.style.right = 'auto';
        ui.style.bottom = '0';
        ui.style.width = width + 'px';

        centerButton.style.position = 'fixed';
        centerButton.style.left = left + width / 2 + 'px';
        centerButton.style.top = top + Math.max(0, bottom - top) / 2 + 'px';
      } else {
        ui.style.position = 'absolute';
        ui.style.left = '0';
        ui.style.right = '0';
        ui.style.bottom = '0';
        ui.style.width = 'auto';

        centerButton.style.position = 'absolute';
        centerButton.style.left = '50%';
        centerButton.style.top = '50%';
      }
    }

    function sync() {
      var duration = video.duration;
      var hasDuration = isFinite(duration) && duration > 0;
      var percent = hasDuration ? (video.currentTime / duration) * 100 : 0;
      var clamped = Math.max(0, Math.min(100, percent));

      progress.style.setProperty('--nomitail-video-progress', clamped.toFixed(2) + '%');
      progress.value = hasDuration ? String(Math.round(clamped * 10)) : '0';
      time.textContent = formatTime(video.currentTime) + ' / ' + formatTime(duration);

      if (video.paused) {
        playButton.setAttribute('aria-label', 'Play video');
        playButton.innerHTML = createIcon('play');
      } else {
        playButton.setAttribute('aria-label', 'Pause video');
        playButton.innerHTML = createIcon('pause');
      }

      if (video.muted) {
        muteButton.setAttribute('aria-label', 'Unmute video');
        muteButton.innerHTML = createIcon('mute');
      } else {
        muteButton.setAttribute('aria-label', 'Mute video');
        muteButton.innerHTML = createIcon('unmute');
      }

      positionControls();
    }

    playButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (video.paused) {
        playVideo(video);
      } else {
        video.pause();
      }
      sync();
    });

    centerButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (video.ended) {
        video.currentTime = 0;
      }
      playVideo(video);
      sync();
    });

    video.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (video.paused) {
        playVideo(video);
      } else {
        video.pause();
      }
      sync();
    });

    muteButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      video.muted = !video.muted;
      if (!video.muted && video.volume === 0) {
        video.volume = 0.6;
      }
      sync();
    });

    fullscreenButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      var requestTarget = frame.requestFullscreen ? frame : video;
      if (requestTarget.requestFullscreen) {
        requestTarget.requestFullscreen().catch(function () {});
      }
    });

    progress.addEventListener('input', function (event) {
      event.stopPropagation();

      if (!isFinite(video.duration) || video.duration <= 0) return;

      var value = Number(event.target.value || 0) / 1000;
      video.currentTime = Math.max(0, Math.min(video.duration, video.duration * value));
      sync();
    });

    [ui, row, playButton, centerButton, progress, time, muteButton, fullscreenButton].forEach(function (node) {
      node.addEventListener('click', stopPropagation);
      node.addEventListener('pointerdown', stopPropagation);
      node.addEventListener('mousedown', stopPropagation);
      node.addEventListener('touchstart', stopPropagation);
    });

    video.addEventListener('loadedmetadata', sync);
    video.addEventListener('durationchange', sync);
    video.addEventListener('timeupdate', sync);
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('volumechange', sync);
    window.addEventListener('resize', positionControls, { passive: true });
    window.addEventListener('scroll', positionControls, { passive: true });

    var slide = video.closest('slideshow-slide');
    if (slide && 'MutationObserver' in window) {
      new MutationObserver(positionControls).observe(slide, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'class'],
      });
    }

    row.appendChild(playButton);
    row.appendChild(time);
    row.appendChild(spacer);
    row.appendChild(muteButton);
    row.appendChild(fullscreenButton);
    ui.appendChild(row);
    ui.appendChild(progress);
    frame.appendChild(centerButton);
    frame.appendChild(ui);

    sync();
  }

  function hydrateDeferredMedia(deferredMedia, shouldPlay) {
    if (!(deferredMedia instanceof HTMLElement)) return;

    var video = deferredMedia.querySelector('video');
    if (!(video instanceof HTMLVideoElement)) {
      video = revealDeferredMedia(deferredMedia);
    }
    if (!(video instanceof HTMLVideoElement)) return;

    normalizeVideo(video);
    hidePoster(deferredMedia);
    ensureControls(video);
    if (shouldPlay) {
      playVideo(video);
    }
  }

  function revealDeferredMedia(deferredMedia) {
    if (!(deferredMedia instanceof HTMLElement)) return null;

    var currentVideo = deferredMedia.querySelector('video');
    if (currentVideo instanceof HTMLVideoElement) return currentVideo;

    var template = deferredMedia.querySelector('template');
    var content = template && template.content && template.content.firstElementChild;
    if (!content) return null;

    var clone = content.cloneNode(true);
    if (!(clone instanceof HTMLElement)) return null;

    if (clone instanceof HTMLVideoElement) {
      normalizeVideo(clone);
    }

    deferredMedia.setAttribute('data-media-loaded', 'true');
    deferredMedia.appendChild(clone);
    hidePoster(deferredMedia);

    return clone instanceof HTMLVideoElement ? clone : deferredMedia.querySelector('video');
  }

  function hydrateAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(DEFERRED_SELECTOR).forEach(function (deferredMedia) {
      hydrateDeferredMedia(deferredMedia, false);
    });
    scope.querySelectorAll(VIDEO_SELECTOR).forEach(function (video) {
      normalizeVideo(video);
      ensureControls(video);
    });
  }

  function onPosterClick(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var button = target.closest(POSTER_BUTTON_SELECTOR);
    if (!button) return;

    var deferredMedia = button.closest('deferred-media');
    var video = revealDeferredMedia(deferredMedia);
    if (video instanceof HTMLVideoElement) {
      normalizeVideo(video);
      hidePoster(deferredMedia);
      ensureControls(video);
      playVideo(video);
    }

    window.setTimeout(function () {
      hydrateDeferredMedia(deferredMedia, true);
    }, 0);
    window.setTimeout(function () {
      hydrateDeferredMedia(deferredMedia, true);
    }, 120);
  }

  function start() {
    injectStyles();
    hydrateAll(document);
    document.addEventListener('click', onPosterClick, true);

    if ('MutationObserver' in window && document.documentElement) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (!(node instanceof HTMLElement)) return;

            if (node.matches && node.matches(DEFERRED_SELECTOR)) {
              hydrateDeferredMedia(node, false);
            }

            hydrateAll(node);
          });
        });
      }).observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
